import { Button } from "../ui/button";

// Single shared "View note" affordance for poll options. Replaces the five
// duplicated hand-rolled pills/links that lived inline in the voting card
// (ranked list, unranked list, multiple-choice row, and both results panels).
//
// It is a compact `ghost` Button: muted text so it reads as secondary to the
// option label, a visible brand focus ring, and a descriptive aria-label so the
// note target is unambiguous for screen-reader / voice-control users.
export function OptionNoteButton({ label, onClick, className = "" }) {
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onClick}
      aria-label={`View note for ${label}`}
      className={`h-auto min-h-6 shrink-0 rounded-full px-2 py-1 text-[11px] font-semibold text-muted-foreground hover:text-card-foreground focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      View note
    </Button>
  );
}
